import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, Container, Group, Text, Title, useMantineTheme } from "@mantine/core";

export interface Error404PageProps {}
export const Error404Page = ({}: Error404PageProps) => {
    const { t } = useTranslation(["common"]);
    const navigate = useNavigate();

    const theme = useMantineTheme();

    return (
        <Container
            style={{
                paddingTop: 80,
                paddingBottom: 80,
            }}
        >
            <Box
                sx={{
                    textAlign: "center",
                    fontWeight: 900,
                    fontSize: 220,
                    lineHeight: 1,
                    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
                    color: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
                    [theme.fn.smallerThan("sm")]: {
                        fontSize: 120,
                    },
                }}
            >
                404
            </Box>
            <Title
                sx={{
                    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
                    textAlign: "center",
                    fontWeight: 900,
                    fontSize: 38,
                    [theme.fn.smallerThan("sm")]: {
                        fontSize: 32,
                    },
                }}
            >
                {t("404_title")}
            </Title>
            <Text
                color="dimmed"
                size="lg"
                align="center"
                style={{
                    maxWidth: 500,
                    margin: "auto",
                    marginTop: theme.spacing.xl,
                    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
                }}
            >
                {t("404_description")}
            </Text>
            <Group position="center">
                <Button variant="subtle" size="md" onClick={() => navigate("/campaigns")}>
                    {t("404_return")}
                </Button>
            </Group>
        </Container>
    );
};
